module.exports = __webpack_public_path__ + "img/cencosud.12e618e6.svg";